import { h, Component } from 'preact';
import shallowEqual from '@os/shallow-equal';
import { newStockAPIStreamer as stockAPIStreamer } from '@os/cloudquote';
import inViewport from '@cube/utils/lib/inViewport';
import isIdle from '@cube/utils/lib/isIdle';
import StockWidgetTable from '../stock-widget-table';

/*
 * A table of stocks, data is passed in by symbol
 * wraps a StockWidgetTable component and handles subscribing
 * to streaming data;
 *
 * This component is basically the same thing as the stock-symbol-table
 * Component found in the finance-components repo, the only difference
 * is that it wraps stock-widget-table instead of stock-info-table
 */

export default class StockTableWrapper extends Component {

	// After 5 minutes, consider the user idle
	idleTimeout = 5 * 60 * 1000;

	onData = (data) => {
		data && this.setState({ data });
	}

	componentDidUnmount() {
		if (this.streamer) this.streamer.end();
	}

	componentDidMount() {
		// Setup the streaming data
		let { symbols } = this.props,
			pollingFn = 'getStockPrice',
			elm = this.base,
			shouldUpdate = () => inViewport(elm) && !isIdle(this.idleTimeout);


		this.streamer = stockAPIStreamer({ symbols, pollingFn, shouldUpdate }).on('data', this.onData);
	}

	componentWillReceiveProps(nextProps) {
		// Update the streamer if the symbols changed
		if (!shallowEqual(this.props.symbols, nextProps.symbols)) {
			this.streamer.stream(nextProps.symbols);
		}
	}

	render(props, { data }) {
		return <StockWidgetTable {...props} data={data} />;
	}
}
